import * as React from "react";
import { useEffect } from "react";
import { stylesheet } from "typestyle";
import { MaterialIcon } from "./icon.js";
import { PushButton } from "./PushButton.js";
import { classNames, toT } from "./utils.js";
import { useCountdown } from "./hooks/countdown.js";
import { Overlay } from "./Overlay.js";
export function MessageOverlay({ open, success, error, message, onClose, strings, autoClose }) {
    const t = toT(strings);
    const countDownActive = Boolean(open && autoClose);
    const left = useCountdown(autoClose !== null && autoClose !== void 0 ? autoClose : 0, countDownActive);
    useEffect(() => {
        if (countDownActive && left <= 0) {
            onClose();
        }
    }, [countDownActive, left, onClose]);
    return (React.createElement(Overlay, { open: open, className: classNames(error && styles.error, success && styles.success) },
        React.createElement("div", { className: styles.icon },
            success && MaterialIcon.check,
            error && MaterialIcon.error),
        React.createElement("div", { className: styles.message }, message),
        React.createElement(PushButton, { onClick: onClose }, t("Close")),
        countDownActive && (React.createElement("div", { className: styles.additionalMessage }, t("AutoCloseMessage", { seconds: left })))));
}
const styles = stylesheet({
    error: {
        backgroundColor: "var(--color-error)",
        color: "#fff",
    },
    success: {
        backgroundColor: "var(--color-success)",
        color: "#fff",
    },
    icon: {
        fontSize: "3em",
        margin: "0.5rem",
        textAlign: "center",
    },
    message: {
        fontSize: "1.25em",
        width: "21em",
        margin: "0.75em",
    },
    additionalMessage: {
        marginTop: "0.75em",
        opacity: 0.75
    }
});
//# sourceMappingURL=MessageOverlay.js.map